import { render } from "./NovoRoteiro.vue?vue&type=template&id=17ab3136"
import script from "./NovoRoteiro.vue?vue&type=script&lang=js"
export * from "./NovoRoteiro.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__